module.exports = __webpack_public_path__ + "static/media/walk-in-the-city.c6443aa1.svg";